import httpClient from "@shared/http/createHttpClient";

export interface EntitlementItem {
  capability_code: string;
  enabled: boolean;
}

export interface MyEntitlementsResponse {
  entitlement_version: number;
  items: EntitlementItem[];
  calculated_at: string;
}

/** 读取当前用户的运行时业务能力；HTTP 客户端负责鉴权和统一错误处理。 */
export async function getMyEntitlements(): Promise<MyEntitlementsResponse> {
  return httpClient.get<MyEntitlementsResponse>("/entitlements/me", {
    silent: true,
  });
}
